<section class="concluido">
  <img src="assets/images/verify-safe-success.png" width="200" alt="seguranca">

  <div class="concluido__title">Código verificado com sucesso!</div>

  <p>Seu dispositivo está pronto para iniciar a Assinatura Eletrônica com mais <strong>tranquilidade e segurança</strong> para você.</p>
</section>
